import React from "react";
import moment from "moment";
import _ from "lodash";
import { Icon, Row, Col, Avatar } from "../../common/UIComponents";
import { Link } from "react-router-dom";
import BaseList from "../BaseList";
import I18n from "../../common/I18n";
import { momentTime } from "../../helpers/date_functions";
import { formatByTimeConfig } from "../../helpers/common";
import { isEmpty } from "../../common/Common";
import { ChevronDownIcon } from "../../common/CustomIcon";

class ActivitiesList extends BaseList {
  constructor(props) {
    super(props);
    this.columns = [
      {
        // title: I18n.t("general.table_s_no"),
        title: "#",
        key: "sequence_no",
        render: (text, record, index) => record.sequence_no,
        width: 55,
      },
      {
        key: "description",
        title: I18n.t("general.description"),
        dataIndex: "description",
        render: (data, record) => (
          <div>
            <Row gutter={16} align="middle">
              <Col xs={2}>
                {record.activity_code === "EXCEPTION" ||
                record.activity_code === "BILLED" ? (
                  <span>
                    <Icon
                      type={
                        record.activity_code === "EXCEPTION"
                          ? "warning"
                          : "file-text"
                      }
                      className={
                        record.activity_code === "EXCEPTION"
                          ? "textRed"
                          : "textPrimary"
                      }
                    />
                  </span>
                ) : (
                  <div className="paddingTop3">
                    <div
                      style={{
                        borderColor: "#009bff",
                      }}
                      className="connectedDot"
                    />
                  </div>
                )}
              </Col>
              <Col xs={22}>
                {data}
                {/* {!isEmpty(record.activity_comments)
                  ? ` (${record.activity_comments})`
                  : ""} */}
              </Col>
            </Row>
          </div>
        ),
      },
      {
        title: I18n.t("invoices.comments"),
        key: "log",
        render: (data, record) => (
          <Row align="middle">
            <Col xs={24}>
             <div>{!isEmpty(record.log) ? ` ${record.log}` : ""}</div>
            {/*{!isEmpty(record.log) && (
              <div style={{ whiteSpace: 'pre-wrap' }}>
                {record.log.replace(/\b(from|to)\b/g, "$1\n")}
              </div>
            )}*/}
          </Col>

          </Row>
        ),
      },
      {
        key: "created_by",
        // title: I18n.t("general.activity_by"),
        title: "User",
        dataIndex: "created_by_name",
        className: "textCaptilize",
        render: (data, record) => (
          <Row align="middle">
            <Col>
              <Avatar
                size={"small"}
                style={{
                  color: "#f56a00",
                  backgroundColor: "#fde3cf",
                  marginRight: "8px",
                }}
              >
                {data?.substring(0, 2)?.toUpperCase()}
              </Avatar>
              <span>{data}</span>
            </Col>
          </Row>
        ),
      },
      {
        key: "activity_on",
        // title: I18n.t("general.activity_on"),
        title: "Date",
        dataIndex: "created_on",
        render: (data) => (
          <Row align="middle">
            <Col>
              {data
                ? `${formatByTimeConfig(
                    momentTime("", data, this.props.timeZone),
                    this.props.isMilitaryTime,
                    "MMM Do, YYYY HH:mm",
                    "MMM Do, YYYY hh:mm A"
                  )} ${
                    this.props.timeZoneName ? ` ${this.props.timeZoneName}` : ""
                  }`
                : ""}
            </Col>
          </Row>
        ),
        sorter: (a, b) => new Date(a.created_on) - new Date(b.created_on),
        defaultSortOrder: 'descend'
      },
    ];
    this.expandIcon = (props) => {
      const { expanded, onExpand, record } = props;
      return (
        <span
          onClick={(e) => onExpand(record, e)}
          style={{ cursor: "pointer" }}
        >
          {expanded ? (
            <ChevronDownIcon
              color="#313D6B"
              style={{ transform: "rotate(180deg)" }}
            />
          ) : (
            <ChevronDownIcon color="#313D6B" />
          )}
        </span>
      );
    }
  }
}

export default ActivitiesList;
